var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-arrow-parent",attrs:{"id":_vm.navigationId
      ? _vm.navigationId
      : ("s-button-" + (_vm.direction === 'left' ? 'prev' : 'next') + "-" + _vm.controlId)}},[_c('div',{staticClass:"carousel-arrow",class:_vm.setClassesFromProps(),style:(_vm.setStyleFromProps())})])}
var staticRenderFns = []

export { render, staticRenderFns }